import { render, staticRenderFns } from "./BookingsByEvent.vue?vue&type=template&id=cedde04a&scoped=true&"
import script from "./BookingsByEvent.vue?vue&type=script&lang=js&"
export * from "./BookingsByEvent.vue?vue&type=script&lang=js&"
import style0 from "./BookingsByEvent.vue?vue&type=style&index=0&id=cedde04a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedde04a",
  null
  
)

export default component.exports